import { Card, CardContent, CardHeader, CardTitle } from '@lombok/ui';
import { PageHeader } from '@/components/PageHeader';
import { DetailRow } from '@/components/DetailRow';
import { FORM_COLUMN } from '@/components/layout';
import { QueryState } from '@/components/QueryState';
import { useSessionProfile } from '@/auth/useSessionProfile';
import { AccountStatusPanel } from '@/features/accounts/AccountStatusPanel';
import { useDistributor } from '@/data/hooks';

/** "Mi cuenta" in the distributor portal: the distributor's own account, read only. */
export function DistributorAccountPage() {
  const { profile } = useSessionProfile();
  const query = useDistributor(profile?.distributorId);

  return (
    <div className={`flex flex-col gap-6 ${FORM_COLUMN}`}>
      <PageHeader title="Mi cuenta" description="Los datos de tu cuenta de distribuidor." />

      {!profile?.distributorId ? (
        <p className="text-sm text-text-muted">Tu usuario aún no está vinculado a una cuenta de distribuidor.</p>
      ) : (
        <QueryState
          isLoading={query.isLoading}
          isError={query.isError}
          error={query.error}
          onRetry={() => void query.refetch()}
          loadingLabel="Cargando tu cuenta…"
        >
          {query.data ? (
            <div className="flex flex-col gap-6">
              <AccountStatusPanel
                accountId={query.data.distributorId}
                status={query.data.status}
                statusReason={query.data.statusReason}
                onChange={async () => undefined}
              />
              <Card>
                <CardHeader>
                  <CardTitle>Información de la cuenta</CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <dl className="flex flex-col">
                    <DetailRow label="Nombre">{query.data.name}</DetailRow>
                    <DetailRow label="RIF">{query.data.rif}</DetailRow>
                  </dl>
                </CardContent>
              </Card>
            </div>
          ) : null}
        </QueryState>
      )}
    </div>
  );
}
